module.exports = __webpack_public_path__ + "static/media/QDCLogo.b415c9fd.png";